import { unaryRpc } from "@redotech/rpc/definition";
import * as zExt from "@redotech/rpc/ext";
import * as z from "zod";

export const cancelAeoOnboarding = unaryRpc({
  name: "cancelAeoOnboarding",
  input: z.object({ teamId: zExt.objectId() }),
  output: z.object({ status: z.string() }),
});
